/**
 * Asynchronously loads the component for CampusProfile
 */

import { lazyLoad } from "utils/loadable";

export const CampusProfile = lazyLoad(
  () => import("./index"),
  (module) => module.CampusProfile
);
